import { render } from "./TwoFactorChallenge_bk.vue?vue&type=template&id=5d4f7970"
import script from "./TwoFactorChallenge_bk.vue?vue&type=script&lang=js"
export * from "./TwoFactorChallenge_bk.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__